const rawPromotionsData = [
  // {
  //   title: "Double Up",
  //   subHeading: "Double Your Deposit Bonus",
  //   status: "Monthly",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: false,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/double-up-challenge",
  //   specialLink: "/",
  //   btnTxt: "Bet Now",
  //   bannerSrc: "/images/promotions/main-banners/DOUBLE-UP-CHALLENGE-XL.webp",
  //   imgSrc: "/images/promotions/main-banners/DOUBLE-UP-CHALLENGE-M.webp",
  //   highlightImgSrc:
  //     "/images/promotions/main-banners/DOUBLE-UP-CHALLENGE-M.webp",
  //   imgIcon: "",
  //   featuredImg: "/",
  //   startDate: "2025-03-24T12:00:00+08:00",
  //   endDate: "2026-03-30T11:59:59+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  // },
  // {
  //   title: "Grand Baccarat Kick-Off",
  //   subHeading: "Over 40,000 Prizes To Be Won",
  //   status: "Weekly",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/grand-baccarat",
  //   specialLink: "https://pp88.asia/tl/grand-baccarat-kick-off-prize-drops/",
  //   btnTxt: "Full T&C",
  //   bannerSrc:
  //     "/images/promotions/main-banners/PRAGMATIC-PLAY_GRAND-BACCARAT-KICK-OFF_XL.webp",
  //   imgSrc:
  //     "/images/promotions/main-banners/PRAGMATIC-PLAY_GRAND-BACCARAT-KICK-OFF_M.webp",
  //   highlightImgSrc:
  //     "/images/promotions/main-banners/PRAGMATIC-PLAY_GRAND-BACCARAT-KICK-OFF_XL.webp",
  //   imgIcon: "/images/icon/lucky-7-free-spins.webp",
  //   featuredImg: "/",
  //   startDate: "2026-06-11T12:00:00+08:00",
  //   endDate: "2026-06-26T12:00:00+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  // },
  {
    title: "Rain Of Wins",
    subHeading: "Weekly Bet Tournament!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/rain-of-wins",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc:
      "/images/promotions/main-banners/RAIN-OF-WINS_WEEKLY_BET_TOURNAMENT-XL.webp",
    imgSrc:
      "/images/promotions/main-banners/RAIN-OF-WINS_WEEKLY_BET_TOURNAMENT-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/RAIN-OF-WINS_WEEKLY_BET_TOURNAMENT-M.webp",
    imgIcon: "/images/icon/lucky-7-free-spins.webp",
    featuredImg: "/",
    startDate: "2026-06-01T12:00:00+08:00",
    endDate: "2026-06-29T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },
  {
    title: "BNG World Cup Fortune Race",
    subHeading: "Total Prize Pool ₱3,575,000",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/world-cup-fortune-race",
    specialLink:
      "https://servicebooongo.com//bngevent/event?event=2026worldcup&lang=en&currency=PHP",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/BNG-WORLD-CUP-FORTUNE-RACE_XL.webp",
    imgSrc: "/images/promotions/main-banners/BNG-WORLD-CUP-FORTUNE-RACE_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/BNG-WORLD-CUP-FORTUNE-RACE_M.webp",
    imgIcon: "/images/icon/lucky-7-free-spins.webp",
    featuredImg: "/",
    startDate: "2026-06-05T13:00:00+08:00",
    endDate: "2026-07-19T00:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },
  {
    title: "PGSoft Global Cash",
    subHeading: "Worth USD 300,000",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/pg-global-cash",
    specialLink: "",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PG-GLOBAL-CASH_TOURNAMENT_WIN_GRAND_PRIZE-XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PG-GLOBAL-CASH_TOURNAMENT_WIN_GRAND_PRIZE-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/PG-GLOBAL-CASH_TOURNAMENT_WIN_GRAND_PRIZE-M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-06-01T12:00:00+08:00",
    endDate: "2026-06-30T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },
  {
    title: "Candy Rush Wheel Drops",
    subHeading: "Collect & Win ₱90,000,000",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/candy-rush-wheel-drops",
    specialLink: "https://pp88.asia/tl/candy-rush-wheel-drops",
    btnTxt: "Full T&C",
    bannerSrc: "/images/promotions/main-banners/CANDY-RUSH-WHEEL-DROPS_XL.webp",
    imgSrc: "/images/promotions/main-banners/CANDY-RUSH-WHEEL-DROPS_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/CANDY-RUSH-WHEEL-DROPS_M.webp",
    imgIcon: "/images/icon/lucky-7-free-spins.webp",
    featuredImg: "/",
    startDate: "2026-06-01T13:00:00+08:00",
    endDate: "2026-06-11T00:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "Fast Cashout Guarantee",
    subHeading: "Get Up to ₱1000 if We're Late!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/fash-cashout-guarantee",
    specialLink: "",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/FGH_FAST-CASHOUT-GUARANTEE_XL.webp",
    imgSrc: "/images/promotions/main-banners/FGH_FAST-CASHOUT-GUARANTEE_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/FGH_FAST-CASHOUT-GUARANTEE_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-05-18T12:00:00+08:00",
    endDate: "2026-06-01T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "Road to Glory",
    subHeading: "Fastspin Tournament Weekly Wins",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/road-to-glory",
    specialLink:
      "https://fastspinpromotion.com/2026_May_Aug_Tournament/?lang=en-US",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/FASTSPIN-ROAD-TO-GLORY_TOURNAMENT_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/FASTSPIN-ROAD-TO-GLORY_TOURNAMENT_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/FASTSPIN-ROAD-TO-GLORY_TOURNAMENT_M.webp",
    imgIcon: "/images/icon/lucky-7-free-spins.webp",
    featuredImg: "/",
    startDate: "2026-05-04T12:00:00+08:00",
    endDate: "2026-08-17T11:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "Jili Grand Slot",
    subHeading: "4 Weeks of Slot Battles & Big Wins!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/jili-grand-slot",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/JILI_GRAND_SLOT_XL.webp",
    imgSrc: "/images/promotions/main-banners/JILI_GRAND_SLOT_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/JILI_GRAND_SLOT_M.webp",
    imgIcon: "/images/icon/lucky-7-free-spins.webp",
    featuredImg: "/",
    startDate: "2026-05-04T12:00:00+08:00",
    endDate: "2026-05-31T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },

  // {
  //   title: "BNG Splash Spin Into Summer",
  //   subHeading: "3,500 Free Spins Up for Grabs!",
  //   status: "Monthly",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/bng-splash",
  //   specialLink: "",
  //   btnTxt: "Leaderboard",
  //   bannerSrc:
  //     "/images/promotions/main-banners/BNG_SPLASH_SPIN_INTO_SUMMER-XL.webp",
  //   imgSrc:
  //     "/images/promotions/main-banners/BNG_SPLASH_SPIN_INTO_SUMMER-M.webp",
  //   highlightImgSrc:
  //     "/images/promotions/main-banners/BNG_SPLASH_SPIN_INTO_SUMMER-M.webp",
  //   imgIcon: "",
  //   featuredImg: "",
  //   startDate: "2026-06-11T00:00:00+08:00",
  //   endDate: "2026-07-17T23:59:00+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  // },
  {
    title: "Sweet Bonanza 2500",
    subHeading: "Sweet Bonanza Wheel Drops 2500",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/pragmatic-play-daily",
    specialLink: "https://pp88.asia/tl/sweet-bonanza-2500-wheel-drops/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_SWEET-BONANZA-2500_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_SWEET-BONANZA-2500_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_SWEET-BONANZA-2500_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-05-05T19:01:00+08:00",
    endDate: "2026-05-19T00:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "BNG Prize Drop",
    subHeading: "Total Prize: ₱13,200,000",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/bng-prize-drop",
    specialLink:
      "https://servicebooongo.com//bngevent/event?event=202604PD&lang=en&currency=PHP",
    btnTxt: "Full T&C",
    bannerSrc: "/images/promotions/main-banners/BNG_PRIZE_NEW_DROP_XL.webp",
    imgSrc: "/images/promotions/main-banners/BNG_PRIZE_NEW_DROP_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/BNG_PRIZE_NEW_DROP_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-04-06T12:00:00+08:00",
    endDate: "2026-06-28T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "Jelly Express Daily Tournament",
    subHeading: "Prize Pool: ₱46,121,600",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/jelly-express",
    specialLink: "https://pp88.asia/tl/jelly-express-daily-tournaments/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_JELLY-EXPRESS_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_JELLY-EXPRESS_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_JELLY-EXPRESS_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-04-06T20:00:00+08:00",
    endDate: "2026-05-04T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "Gates of Olympus Roulette",
    subHeading: "2,150 Daily Prizes up to ₱841,000",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/gates-of-olympus",
    specialLink:
      "https://ppgames.asia/tl/gates-of-olympus-roulette-daily-prize-drops/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_GATES-OF-OLYMPUS_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_GATES-OF-OLYMPUS_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY_GATES-OF-OLYMPUS_M.webp",
    imgIcon: "",
    featuredImg: "",
    startDate: "2026-04-10T01:00:00+08:00",
    endDate: "2026-04-17T00:59:00+08:00",
    thursdayPromotion: true,
    fridayPromotion: true,
    isInMainslider: true,
  },
  {
    title: "Race of Reels: Slots Tournament",
    subHeading: "Win 888 Free Spins Weekly in Pragmatic Play",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/race-of-reels",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc:
      "/images/promotions/main-banners/RACE_OF_REELS_PROMOTION_BANNER-XL.webp",
    imgSrc:
      "/images/promotions/main-banners/RACE_OF_REELS_PROMOTION_BANNER-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/RACE_OF_REELS_PROMOTION_BANNER-M.webp",
    imgIcon: "/images/icon/lucky-8-free-spins.webp",
    featuredImg: "",
    startDate: "2026-03-03T12:00:00+08:00",
    endDate: "2026-03-31T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "TPGreat Spins of Fortune",
    subHeading: "Win up to ₱2,500 FREE Credits Weekly this Chinese New Year!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/tpg-great-spins-of-fortune",
    specialLink: "",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/TPG_GREAT_SPINS_OF_FORTUNE_XL.webp",
    imgSrc: "/images/promotions/main-banners/TPG_GREAT_SPINS_OF_FORTUNE_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/TPG_GREAT_SPINS_OF_FORTUNE_M.webp",
    imgIcon: "/images/icon/fortune-icon.webp",
    featuredImg: "",
    startDate: "2026-02-17T12:00:00+08:00",
    endDate: "2026-03-17T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "JDB Spin Tournament",
    subHeading: "Win up to 500 FREE SPINS every week!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/love-magic-spin",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/LOVE_AND_MAGIC_XL.webp",
    imgSrc: "/images/promotions/main-banners/LOVE_AND_MAGIC_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/LOVE_AND_MAGIC_M.webp",
    imgIcon: "/images/icon/chocolate-icon.webp",
    featuredImg: "",
    startDate: "2026-02-02T12:00:00+08:00",
    endDate: "2026-03-02T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },
  {
    title: "CQ9 King of Betting",
    subHeading: "Total prize soars to ₱8,000,000",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/king-of-betting",
    specialLink: "https://betking.jiamengweiquan.com/newyearph",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/CQ9_KING-OF-BETTING_NEW-XL.webp",
    imgSrc: "/images/promotions/main-banners/CQ9_KING-OF-BETTING_NEW-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/CQ9_KING-OF-BETTING_NEW-M.webp",
    imgIcon: "/images/icon/featured-bell.webp",
    featuredImg:
      "/images/promotions/featured-promotions/fgh-funalo-sa-pasko-featured.webp",
    startDate: "2026-02-05T12:00:00+08:00",
    endDate: "2026-03-05T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "Fortune Drops 2026",
    subHeading: "Win Instantly While You Play in FGH!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/fortune-drops",
    specialLink: "",
    btnTxt: "Full T&C",
    bannerSrc: "/images/promotions/main-banners/FORTUNE-DROPS-V2_XL.webp",
    imgSrc: "/images/promotions/main-banners/FORTUNE-DROPS-V2_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/FORTUNE-DROPS-V2_M.webp",
    imgIcon: "/images/icon/fortune-icon.webp",
    featuredImg: "",
    startDate: "2026-01-05T12:00:00+08:00",
    endDate: "2026-02-02T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },

  {
    title: "BNG Bet Race",
    subHeading: "Total Prize: ₱2,200,000",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/bng-bet-race",
    specialLink:
      "https://servicebooongo.com//bngevent/event?event=202601BR&lang=en&currency=PHP",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/BNG-BET-RACE_XL.webp",
    imgSrc: "/images/promotions/main-banners/BNG-BET-RACE_M.webp",
    highlightImgSrc: "",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2026-01-01T12:00:00+08:00",
    endDate: "2026-01-08T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  // {
  //   title: "CQ9 Funalo",
  //   subHeading: "Araw Araw FUNALO ngayong Pasko!",
  //   status: "Monthly",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/cq9-funalo",
  //   specialLink: "",
  //   btnTxt: "Leaderboard",
  //   bannerSrc: "/images/promotions/main-banners/CQ9_FUNALO_FGH_XL.webp",
  //   imgSrc: "/images/promotions/main-banners/CQ9_FUNALO_FGH_M.webp",
  //   highlightImgSrc: "/images/promotions/main-banners/CQ9_FUNALO_FGH_M.webp",
  //   imgIcon: "/images/icon/featured-bell.webp",
  //   featuredImg:
  //     "/images/promotions/featured-promotions/fgh-funalo-sa-pasko-featured.webp",
  //   startDate: "2025-12-01T12:00:00+08:00",
  //   endDate: "2025-12-31T11:59:59+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  //   isShowOnFeatured: true,
  // },

  {
    title: "CQ9 Christmas",
    subHeading: "Total prize soars to ₱250,000,000",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/cq9-christmas",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/CQ9_CHRISTMAS_XL.webp",
    imgSrc: "/images/promotions/main-banners/CQ9_CHRISTMAS_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/CQ9_CHRISTMAS_M.webp",
    imgIcon: "",
    featuredImg: "",
    startDate: "2025-12-18T12:00:00+08:00",
    endDate: "2026-01-15T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },

  {
    title: "TPG Rise of Hellfire",
    subHeading: "Ultimate Challenge",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/tpg-rise-of-hell-fire",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/TPG-RISE_OF_HELLFIRE_XL.webp",
    imgSrc: "/images/promotions/main-banners/TPG-RISE_OF_HELLFIRE_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/TPG-RISE_OF_HELLFIRE_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2025-12-01T00:00:00+08:00",
    endDate: "2025-12-29T23:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  {
    title: "8PM Recovery Hour",
    subHeading: "Get 8% Recovery Bonus on Your Next Deposit",
    status: "Daily",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/recovery-hour",
    specialLink: "",
    btnTxt: "Deposit Now",
    bannerSrc: "/images/promotions/main-banners/RECOVERY-HOUR-4HOURS-XL.webp",
    imgSrc: "/images/promotions/main-banners/RECOVERY-HOUR-4HOURS_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/RECOVERY-HOUR-4HOURS_M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-11-10T00:00:00+08:00",
    endDate: "2025-12-10T23:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },
  {
    title: "Flexi-Spin Showdown",
    subHeading: "Go Big or Go Many!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/flexi-spin-showdown",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/FLEXI-SPIN-SHOWDOWN_XL.webp",
    imgSrc: "/images/promotions/main-banners/FLEXI-SPIN-SHOWDOWN_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/FLEXI-SPIN-SHOWDOWN_M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-11-01T00:00:00+08:00",
    endDate: "2025-11-29T23:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },

  {
    title: "Super Scatter Daily Tournaments",
    subHeading: "Daily Slot Tournament",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/pragmatic-play-daily-tournament/",
    specialLink: "https://pp88.asia/tl/super-scatter-series-daily-tournaments/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-DAILY-TOURNAMENTS_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-DAILY-TOURNAMENTS_M.webp",
    highlightImgSrc: "",
    imgIcon: "",
    featuredImg: "",
    startDate: "2025-10-31T20:00:00+08:00",
    endDate: "2025-11-14T00:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },

  {
    title: "8's Your Lucky Draw",
    subHeading: "All Eyes on 8, Play Smart & Win Big!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/8-lucky-draw",
    specialLink: "",
    btnTxt: "View Entry",
    bannerSrc: "/images/promotions/main-banners/LUCKY-DRAW_XL.webp",
    imgSrc: "/images/promotions/main-banners/LUCKY-DRAW_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/LUCKY-DRAW_M.webp",
    imgIcon: "/images/icon/lucky-8-free-spins.webp",
    featuredImg: "/",
    startDate: "2025-10-01T00:00:00+08:00",
    endDate: "2025-10-27T23:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: true,
  },

  // {
  //   title: "8PM RECOVERY HOUR",
  //   subHeading: "Get 8% Recovery Bonus on Your Next Deposit - 1 Hour Only!",
  //   status: "Monthly",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/recovery-bonus",
  //   specialLink: "/",
  //   btnTxt: "Deposit Now",
  //   bannerSrc:
  //     "/images/promotions/main-banners/FGH-RECOVERY-BONUS_XL_8_BONUS.webp",
  //   imgSrc: "/images/promotions/main-banners/FGH-RECOVERY-BONUS_M.webp",
  //   highlightImgSrc:
  //     "/images/promotions/main-banners/FGH-RECOVERY-BONUS_M.webp",
  //   imgIcon: "/images/icon/RECOVERY-BONUS-ICON.webp",
  //   featuredImg: "/",
  //   startDate: "2025-11-10T12:00:00+08:00",
  //   endDate: "2025-12-10T12:00:00+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  //   isShowOnFeatured: true,
  // },

  {
    title: "FC Grand Spin-Ale",
    subHeading: "October's biggest spin celebration is here!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/fcgrand-spin-ale",
    specialLink: "/",
    btnTxt: "Leaderboard",
    bannerSrc:
      "/images/promotions/main-banners/FACHAI_FGH-GRAND-SPIN_ALE_XL.webp",
    imgSrc: "/images/promotions/main-banners/FACHAI_FGH-GRAND-SPIN_ALE_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/FACHAI_FGH-GRAND-SPIN_ALE_M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2025-10-01T12:00:00+08:00",
    endDate: "2025-10-31T11:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: false,
    isShowOnFeatured: false,
  },
  {
    title: "TPG Trick or Treat",
    subHeading: "Weekly Challenge",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/tpg-games",
    specialLink:
      "https://tournament.triple-pg.com/tpg-trick-or-treat-weekly-challenge/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/TPG-TRICK-OR-TREAT-WEEKLY_XL.webp",
    imgSrc: "/images/promotions/main-banners/TPG-TRICK-OR-TREAT-WEEKLY_M.webp",
    highlightImgSrc: "",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2025-11-01T00:00:00+08:00",
    endDate: "2025-11-28T23:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },

  {
    title: "CQ9 Moon Festival",
    subHeading: "Divine Blessings, Daily Rewards",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/cq9-gaming",
    specialLink: "https://betking.jiamengweiquan.com/autumnwinph",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/CQ9_DIVINE_BLESSINGS_FGH-XL.webp",
    imgSrc: "/images/promotions/main-banners/CQ9_DIVINE_BLESSINGS_FGH-M.webp",
    highlightImgSrc: "",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2025-09-25T12:00:00+08:00",
    endDate: "2025-10-23T12:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },

  // {
  //   title: "Jolliplay Exclusive Campaign",
  //   subHeading: "Play JolliPlay → Hit the turnover → Win Free Spins!",
  //   status: "On-hold",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/jolliplay-exclusive-campaign",
  //   specialLink: "",
  //   btnTxt: "Full T&C",
  //   bannerSrc:
  //     "/images/promotions/main-banners/JOLLIPLAY-GOLDEN-EGYPT-QUEST_XL.webp",
  //   imgSrc:
  //     "/images/promotions/main-banners/JOLLIPLAY-GOLDEN-EGYPT-QUEST_M.webp",
  //   highlightImgSrc:
  //     "/images/promotions/main-banners/JOLLIPLAY-GOLDEN-EGYPT-QUEST_M.webp",
  //   imgIcon: "/images/icon/free-spins.webp",
  //   featuredImg: "/",
  //   startDate: "2025-09-01T00:00:00+08:00",
  //   endDate: "2025-09-30T23:59:00+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  //   isShowOnFeatured: true,
  // },
  {
    title: "Pragmatic Play Zombie School",
    subHeading: "Jackpot Blaze Daily Tournaments",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/pragmatic-zombie-school",
    specialLink: "/",
    btnTxt: "Play Now",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-JACKPOT-BLAZE_DAILY_TOURNAMENTS_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-JACKPOT-BLAZE_DAILY_TOURNAMENTS_M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-JACKPOT-BLAZE_DAILY_TOURNAMENTS_M.webp",
    imgIcon: "/images/icon/RECOVERY-BONUS-ICON.webp",
    featuredImg: "/",
    startDate: "2025-08-29T08:00:00+08:00",
    endDate: "2025-09-13T12:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
    isShowOnFeatured: false,
  },

  // {
  //   title: "JolliPlay Free Spins Code",
  //   subHeading: "30 Winners Daily! Grab Yours from CSR Now!",
  //   status: "On-hold",
  //   userQualification: "",
  //   userRewards: "",
  //   onClickFunction: "",
  //   featuredPromotion: true,
  //   highlightPromotion: false,
  //   tncLink: "/promotion/jolli-play",
  //   specialLink: "",
  //   btnTxt: "Full T&C",
  //   bannerSrc: "/images/promotions/main-banners/JOLLIPLAY_PROMO_XL.webp",
  //   imgSrc: "/images/promotions/main-banners/JOLLIPLAY_PROMO_M.webp",
  //   highlightImgSrc: "/images/promotions/main-banners/JOLLIPLAY_PROMO_M.webp",
  //   imgIcon: "/images/icon/free-spins.webp",
  //   featuredImg: "/",
  //   startDate: "2025-09-01T12:00:00+08:00",
  //   endDate: "2025-09-30T11:59:00+08:00",
  //   thursdayPromotion: false,
  //   fridayPromotion: false,
  //   isInMainslider: true,
  //   isShowOnFeatured: true,
  // },

  {
    title: "FGH Sign-Up Treat",
    subHeading: "Up to 150,000 Total Free Spins on JILI Slots!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/sign-up-treat",
    specialLink: "/",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/FGH-SIGN-UP-TREAT-XL.webp",
    imgSrc: "/images/promotions/main-banners/FGH-SIGN-UP-TREAT-M.webp",
    highlightImgSrc: "/images/promotions/main-banners/FGH-SIGN-UP-TREAT-M.webp",
    imgIcon: "",
    featuredImg: "/",
    startDate: "2025-07-07T12:00:00+08:00",
    endDate: "2025-08-06T11:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "JDB Exclusive Promo",
    subHeading: "Just Do Your Best, We'll Handle the Rest!",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/jdb-exclusive-promo",
    specialLink: "/",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/JUST-DO-YOUR-BEST_XL.webp",
    imgSrc: "/images/promotions/main-banners/JUST-DO-YOUR-BEST_M.webp",
    highlightImgSrc: "/images/promotions/main-banners/JUST-DO-YOUR-BEST_M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-07-01T12:00:00+08:00",
    endDate: "2025-07-31T11:59:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "BETSOFT Lucky Wheel",
    subHeading: "Spin Now for Weekly Rewards",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/betsoft-lucky-wheel",
    specialLink: "/",
    btnTxt: "",
    bannerSrc:
      "/images/promotions/main-banners/betsoft-lucky-wheel-desktop.webp",
    imgSrc: "/images/promotions/main-banners/betsoft-lucky-wheel-mobile.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/betsoft-lucky-wheel-mobile.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-06-27T00:01:00+00:00",
    endDate: "2025-07-31T23:59:00+00:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },
  {
    title: "Independence Celebration",
    subHeading: "Double the Bonus, Double the Fun!",
    status: "Daily",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/independence-celebration",
    specialLink: "/",
    btnTxt: "See More",
    bannerSrc:
      "/images/promotions/main-banners/INDEPENDENCE_CELEBRATION-XL.webp",
    imgSrc: "/images/promotions/main-banners/INDEPENDENCE_CELEBRATION-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/INDEPENDENCE_CELEBRATION-M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-06-12T12:00:00+08:00",
    endDate: "2025-06-19T21:00:00+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "King of the Reels",
    subHeading: "High Roller Tournament",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/king-of-the-reels",
    specialLink: "/",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/KING_OF_THE_REELS-XL.webp",
    imgSrc: "/images/promotions/main-banners/king-of-reels-banner-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/king-of-reels-banner-M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2025-06-02T12:00:00+08:00",
    endDate: "2025-06-30T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
    isInMainslider: true,
  },

  {
    title: "Saturday Spin Surprize",
    subHeading: "Free Spins Giveaway",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/spin-surprize",
    specialLink: "/",
    btnTxt: "Turnover",
    bannerSrc: "/images/promotions/main-banners/saturday-spin-surprize-XL.webp",
    imgSrc: "/images/promotions/main-banners/saturday-spin-surprize-M.webp",
    highlightImgSrc:
      "/images/promotions/main-banners/saturday-spin-surprize-M.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: "2025-05-03T12:00:00+08:00",
    endDate: "2025-05-31T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
  },

  {
    title: "Daily Wins",
    subHeading: "4 Daily Tournaments",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/daily-wins",
    specialLink: "https://pp88.asia/tl/promotion/daily-wins/",
    btnTxt: "Full T&C",
    bannerSrc:
      "/images/promotions/main-banners/PRAGMATIC-PLAY-DAILY-WINS_XL.webp",
    imgSrc: "/images/promotions/main-banners/PRAGMATIC-PLAY-DAILY-WINS_M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "/",
    startDate: "2026-03-30T12:00:00+08:00",
    endDate: "2027-04-28T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Race to Riches",
    subHeading: "Bigger Wins with JILI Free Spins",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/race-to-riches",
    specialLink: "",
    btnTxt: "Leaderboard",
    bannerSrc: "/images/promotions/main-banners/race-to-riches-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/race-to-riches-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: "2025-04-01T12:00:00+08:00",
    endDate: "2025-04-29T11:59:59+08:00",
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Exclusive Rolling Commission",
    subHeading: "Keep rolling into riches",
    status: "Daily",
    // userQualification: "Total Points :",
    // userRewards: "100,000",
    onClickFunction: "",
    featuredPromotion: true,
    highlightPromotion: false,
    tncLink: "/promotion/vip-rolling-commission",
    specialLink: "",
    btnTxt: "View",
    bannerSrc:
      "/images/promotions/main-banners/vip-rolling-commission-banner-new_XL.webp",
    imgSrc:
      "/images/promotions/main-banners/vip-rolling-commission-banner-new_M.webp",
    highlightImgSrc:
      "/images/promotions/fgh-vvip-rolling-commission-featured.webp",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: "",
    endDate: "",
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "New Member Bonus",
    subHeading: "Claim up to ₱1,250 in Bonuses!",
    status: "",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/new-member-bonus",
    specialLink: "",
    btnTxt: "",
    bannerSrc:
      "/images/promotions/main-banners/new-member-package-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/new-member-package-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "2/30 Lottery Draw",
    subHeading: "Guess the winning number",
    status: "Weekly",
    userQualification: "Qualified",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: true,
    tncLink: "/promotion/2-30-lottery-draw",
    specialLink: "",
    btnTxt: "Guess Now",
    bannerSrc: "/images/promotions/main-banners/lottery-draw-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/lottery-draw-banner-M.webp",
    highlightImgSrc: "/images/promotions/fgh-lottery-draw-featured.webp",
    imgIcon: "/images/icon/lottery-icon.webp",
    featuredImg:
      "/images/promotions/featured-promotions/fgh-lottery-draw-featured-img.webp",
    startDate: "2026-04-26T12:00:00+08:00",
    endDate: "2026-04-29T12:00:00+08:00",
    thursdayPromotion: true,
    fridayPromotion: false,
  },

  {
    title: "Third Time's a Charm",
    subHeading: "20% Daily Deposit Bonus",
    status: "Daily",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/third-time-charm-deposit-bonus",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/deposit-bonus-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners//deposit-bonus-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Pera O Bayong",
    subHeading: "Mystery Friday",
    status: "Weekly",
    userQualification: "Qualified",
    userRewards: "",
    onClickFunction: "handleOpenModule",
    featuredPromotion: true,
    highlightPromotion: true,
    tncLink: "/promotion/pera-o-bayong",
    specialLink: "",
    btnTxt: "Claim Prize",
    bannerSrc: "/images/promotions/main-banners/pera-o-bayong-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/pera-o-bayong-banner-M.webp",
    highlightImgSrc: "/images/promotions/fgh-pera-o-bayong-featured.webp",
    imgIcon: "/images/icon/pera-bayong-icon.webp",
    featuredImg:
      "/images/promotions/featured-promotions/fgh-pera-o-bayong-featured.webp",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: true,
  },
  {
    title: "Become an Agent",
    subHeading: "Earn up to 40% Monthly Commission",
    status: "",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/agent-monthly-commission",
    specialLink: "",
    btnTxt: "",
    bannerSrc:
      "/images/promotions/main-banners/monthly-commission-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/monthly-commission-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "VVIP Weekly Rewards",
    subHeading: "Earn Up to ₱10,000 - Exlusive for FGH High Rollers",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/vip-weekly-rewards",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/vvip-weekly-rewards-XL.webp",
    imgSrc: "/images/promotions/main-banners/vvip-weekly-rewards-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "VIP Referral Program",
    subHeading: "Earn up to 19% Referral Commission",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/vip-referral-program",
    specialLink: "",
    btnTxt: "",
    bannerSrc:
      "/images/promotions/main-banners/vip-referral-bonus-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/vip-referral-bonus-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Weekly Cashback",
    subHeading: "Up to 7% cashback",
    status: "Weekly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/weekly-cashback",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/weekly-cashback-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/weekly-cashback-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Birthday Bonus",
    subHeading: "Get up to ₱2,000 credits",
    status: "",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/birthday-bonus",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/birthday-bonus-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/birthday-bonus-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
  {
    title: "Payday Bonus",
    subHeading: "Get up to ₱1,800 Bonus",
    status: "Monthly",
    userQualification: "",
    userRewards: "",
    onClickFunction: "",
    featuredPromotion: false,
    highlightPromotion: false,
    tncLink: "/promotion/payday-bonus",
    specialLink: "",
    btnTxt: "",
    bannerSrc: "/images/promotions/main-banners/payday-bonus-banner-XL.webp",
    imgSrc: "/images/promotions/main-banners/payday-bonus-banner-M.webp",
    highlightImgSrc: "",
    imgIcon: "/images/icon/FGH-BAG-ICON.webp",
    featuredImg: "",
    startDate: null,
    endDate: null,
    paydayPromotion: true,
    thursdayPromotion: false,
    fridayPromotion: false,
  },
]
const getManilaDateParts = (date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Manila",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(date)

  return Object.fromEntries(parts.map(({ type, value }) => [type, value]))
}

const getMonthlyPaydayWindow = (now = new Date()) => {
  const { year, month } = getManilaDateParts(now)

  const startDateString = `${year}-${month}-15T12:00:00+08:00`
  const endDateString = `${year}-${month}-18T12:00:00+08:00`

  return {
    startDateString,
    endDateString,
    startDate: new Date(startDateString),
    endDate: new Date(endDateString),
  }
}

export const promotionsData = rawPromotionsData
  .map((promotion, index) => {
    let promotionMessage = { text: "On-going", class: "ongoing" }

    const now = new Date()
    const isPaydayPromotion = promotion.paydayPromotion === true

    let startDateString = promotion.startDate
    let endDateString = promotion.endDate
    let startDate = promotion.startDate ? new Date(promotion.startDate) : null
    let endDate = promotion.endDate ? new Date(promotion.endDate) : null

    if (isPaydayPromotion) {
      const paydayWindow = getMonthlyPaydayWindow(now)

      startDateString = paydayWindow.startDateString
      endDateString = paydayWindow.endDateString
      startDate = paydayWindow.startDate
      endDate = paydayWindow.endDate

      // Only display Payday Bonus from every 15th 12:00 PM
      // until before every 18th 12:00 PM, Philippine time.
      // if (now < startDate || now >= endDate) {
      //   return null
      // }
    }

    if (promotion.status === "On-hold") {
      promotionMessage = { text: "On-hold", class: "onhold" }
    } else if (startDate && endDate) {
      const allowanceEnd = isPaydayPromotion
        ? endDate
        : new Date(endDate.getTime() + 48 * 60 * 60 * 1000)

      if (isPaydayPromotion) {
        promotionMessage = { text: "On-going", class: "ongoing" }
      } else if (now < startDate) {
        promotionMessage = { text: "Upcoming", class: "upcoming" }
      } else if (now > allowanceEnd) {
        return null
      } else if (now > endDate) {
        promotionMessage = { text: "Ended", class: "ended" }
      } else {
        promotionMessage = { text: "On-going", class: "ongoing" }
      }
    }

    return {
      ...promotion,
      id: index + 1,
      startDate: startDateString,
      endDate: endDateString,
      ended: promotionMessage.class === "ended",
      promotionMessage,
    }
  })
  .filter(Boolean)

// promotiondata.jsx (updated export)
export const sliderPromotions = promotionsData.filter(
  (promo) => promo.isInMainslider && !promo.ended && promo.bannerSrc
)
